import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "./Layout";
import Home from "./pages/Home";
import Art from "./pages/Art";
import ArtworkDetail from "./pages/ArtworkDetail";
import Remembering from "./pages/Remembering";
import Share from "./pages/Share";
import Photos from "./pages/Photos";
import PhotoDetail from "./pages/PhotoDetail";
import Life from "./pages/Life";
import Motion from "./pages/Motion";
import Arrangements from "./pages/Arrangements";
import Correction from "./pages/Correction";
import AdminApp from "./admin/AdminApp";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function LouiseApp() {
  return (
    <>
      <ScrollTop />
      <Routes>
        <Route path="admin" element={<AdminApp />} />
        <Route path="*" element={
          <Layout>
            <Routes>
              <Route index element={<Home />} />
              <Route path="art" element={<Art />} />
              <Route path="art/:id" element={<ArtworkDetail />} />
              <Route path="remembering" element={<Remembering />} />
              <Route path="share" element={<Share />} />
              <Route path="photographs" element={<Photos />} />
              <Route path="photographs/album/:albumId" element={<Photos />} />
              <Route path="photographs/photo/:id" element={<PhotoDetail />} />
              <Route path="life" element={<Life />} />
              <Route path="in-motion" element={<Motion />} />
              <Route path="arrangements" element={<Arrangements />} />
              <Route path="service" element={<Arrangements />} />
              <Route path="correction" element={<Correction />} />
              <Route path="*" element={<p className="max-w-4xl mx-auto px-6 py-32 font-lou text-2xl">This page could not be found.</p>} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </>
  );
}
